<template>
  <div class="smsCode">
    <div class="back_icon_box" @click="back">
      <van-icon name="arrow-left" size="24" />
    </div>

    <div class="title_box">
      <div class="text1">输入验证码</div>
      <div class="text2">验证码已发送至 {{tel}}</div>
    </div>

    <div class="code_input_box">
      <CodeInput
        @finish="codeSuccess"
      />
    </div>

    <div class="tip">
      <span v-if="timer">{{count}}秒后重新获取验证码</span>
      <span @click="sendCode" v-else>未收到验证码点这里</span>
    </div>

    <van-overlay :show="maskloading">
      <div style="height: 100%;display: flex;align-items: center;justify-content: center;">
        <van-loading type="spinner" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Icon, Field, Toast, Loading, Overlay } from 'vant'
import CodeInput from '@/components/codeInput.vue'
import { ApiSendCode, ApiLogin, ApiGetInfo } from '@/api/login.js'

export default {
  name: 'smsCode',
  components: {
    vanIcon: Icon,
    vanField: Field,
    vanLoading: Loading,
    vanOverlay: Overlay,
    CodeInput
  },
  data() {
    return {
      tel: '',
      code: '',
      timer: null,
      count: 60,
      loading: false,
      maskloading: false,
    }
  },
  mounted() {
    this.tel = this.$route.query.tel

    this.startTimer()
  },
  destroyed() {
    this.stopTimer()
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    startTimer() {
      if (this.timer) {
        this.stopTimer()
      }

      this.timer = setInterval(() => {
        this.count--

        if (this.count <= 0) {
          this.stopTimer()
        }
      }, 1000)
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
        this.count = 60
      }
    },
    sendCode() {
      if (this.loading) return false

      this.loading = true
      ApiSendCode({
        phone: this.tel
      }).then(res => {
        this.loading = false
        Toast(res.msg)
        if (res.code === 200) {
          this.startTimer()
        }
      }).catch(() => {
        this.loading = false
      })
    },
    async codeSuccess(value) {
      // console.log(value)
      let params = {
        "grant_type": "password",
        "scope": "Dayulong offline_access",
        "client_id": "Dayulong_App",
        "client_secret": "Dayulong88888888",
        "loginType": "14",
        "mobile": this.tel,
        "code": value,
        username: value,
        password: value,
        openId: localStorage.getItem('openId')
      }

      this.maskloading = true

      try {
        let result = await ApiLogin(params)
        
        localStorage.setItem('appUserToken', result.access_token)
        localStorage.setItem('openId', '')

        this.getUserInfo()
      } catch (error) {
        this.maskloading = false

        if (error.response) {
          let error_description = error.response.data.error_description
          Toast(error_description || '登录失败')
        } else {
          Toast('登录失败')
        }
      }

      // localStorage.setItem('tel', this.tel)
      // localStorage.setItem('smsCode', value)
      // // let originUrl = encodeURI(location.origin + '/olympicMusicShow/home?bindPhone=1')
			// location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + this.$store.state.index.appId + '&redirect_uri=' + originUrl + '&response_type=code&scope=snsapi_userinfo&state=2'
    },
    getUserInfo() {
      ApiGetInfo().then(res => {
        this.maskloading = false
        if (res.code === 200) {
          let data = res.data
          data.userId = data.id
          this.$store.commit('index/setUserInfo', data)
          this.$router.push({ path: 'home' })
        } else {
          Toast(res.msg)
        }
      }).catch(() => {
        this.maskloading = false
        Toast('获取用户信息失败')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/flexable.scss';

.smsCode {
  position: relative;
  .back_icon_box {
    position: absolute;
    top: px2rem(33);
    left: px2rem(33);
    z-index: 1;
  }

  .title_box {
    margin-bottom: px2rem(100);
    width: 100%;
    padding-top: px2rem(170);
    padding-left: px2rem(70);
    text-align: left;
    box-sizing: border-box;
    .text1 {
      margin-bottom: px2rem(25);
      font-size: px2rem(48);
      font-weight: bold;
      color: #1F1F1F;
      line-height: 1;
    }
    .text2 {
      font-size: px2rem(34);
      font-weight: 500;
      color: #1F1F1F;
      line-height: 1;
    }
  }

  .code_input_box {
    margin: 0 auto;
    width: px2rem(650);
  }

  .vue-pincode-input {
    border-bottom: 1px solid #000;
  }

  .tip {
    padding-top: px2rem(90);
    padding-left: px2rem(70);
    text-align: left;
    font-size: px2rem(28);
    font-weight: 500;
    color: #585858;
  }
}
</style>